import BaseCtrl from 'edge/platform/base/BaseCtrl';
import _ from 'underscore';

var fn = function fn($scope, StateUtils) {
    var ctrl = Object.create(BaseCtrl);
    var flowModel = StateUtils.activeDataForState(true).flowModel;

    /**
     * Method used by wizard ribbon set styles for active and visited steps in the wizard flow
     */
    function refreshStepsFn() {
        function setStepClasses(wizardSteps) {
            if (wizardSteps.length > 0) {
                var currentStateIdx = _.findIndex(wizardSteps, function (step) {
                    return step.name === flowModel.currentStep.name;
                });

                for (var stepIdx = 0; stepIdx < wizardSteps.length; stepIdx++) {
                    var step = wizardSteps[stepIdx];
                    var visited = stepIdx <= currentStateIdx;
                    var activeClass = currentStateIdx === stepIdx ? 'gw-current' : '';
                    var notVisitedClass = visited || stepIdx === 0 ? '' : 'gw-not-visited';
                    var visitedClass = visited && currentStateIdx === stepIdx ? 'gw-visited' : '';
                    var allowedVisitClass = flowModel.isStepAccessibleFromCurrent(step) ? '' : 'gw-not-allowed';
                    step.styleClass = activeClass + ' ' + notVisitedClass + ' ' + visitedClass + ' ' + allowedVisitClass;
                }
            }
        }
        if (StateUtils.activeDataForState(true).model) {
            $scope.wizardSteps.length = 0;
            Array.prototype.push.apply($scope.wizardSteps, flowModel.steps);
            $scope.ribbonVisible = $scope.wizardSteps.length > 0;
            setStepClasses($scope.wizardSteps);
        }
    }

    ctrl.init = function () {
        if (!flowModel) {
            return;
        }
        $scope.wizardSteps = [];
        $scope.ribbonVisible = false;
        refreshStepsFn();

        flowModel.addStepChangeListener(refreshStepsFn);

        var onStateTransition = function onStateTransition(actionHandlerObject, promise) {
            $scope.stateTransitionPromise = promise;

            try {
                var messageObject = void 0;
                if (_.isFunction(actionHandlerObject.msgs)) {
                    messageObject = actionHandlerObject.msgs();
                } else {
                    messageObject = actionHandlerObject.msgs;
                }
                $scope.stateTransitionMessage = messageObject.progress.message;
            } catch (ignore) {/* it's ok if there's no message */
            }
        };
        StateUtils.subscribeToStateTransitions(onStateTransition);

        $scope.$on('$destroy', function () {
            flowModel.removeStepChangeListener(refreshStepsFn);
            StateUtils.unsubscribeFromStateTransitions(onStateTransition);
        });
    };

    /**
     * Method used by wizard ribbon to move between steps.
     * @param {Object} step - selected step
     */
    ctrl.selectStep = function (step) {
        StateUtils.jumpToTheStep(step);
    };

    ctrl.stepLabel = function (step) {
        return step.label();
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'StateUtils'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/wizard/_WizardStepsCtrl.js
// module id = 360
// module chunks = 0